module.exports = __webpack_public_path__ + "static/cat-journey-ef7e390de71367c6ba0fc716cff5a3a8.png";